import classNames from "classnames";
import { ReactComponent as CheckOn } from "../../../../assets/images/svg/twoPartyContract/check-on.svg";
import { ReactComponent as CheckOff } from "../../../../assets/images/svg/twoPartyContract/check-off.svg";
import styles from "./ui.module.scss";

interface ICheckRowProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/** One installment option: the design's 20px check-square and its label. */
const CheckRow = ({ label, checked, onChange }: ICheckRowProps) => (
  <button
    type="button"
    role="checkbox"
    aria-checked={checked}
    className={classNames(styles.checkRow, {
      [styles.checkRowChecked]: checked,
    })}
    onClick={() => onChange(!checked)}>
    {checked ? <CheckOn /> : <CheckOff />}
    <span>{label}</span>
  </button>
);

export default CheckRow;
